function TwoColumn({ children }) {
  return (
    <div className="two-column">
      {children}
    </div>
  );
}

export default TwoColumn;